import { useContext } from 'react';
import { Lesson } from '../../../../../../../types/Assemblage';
import { ClassContext, UserContext } from 'edrolo/context';
import { Tooltip, Progress, enums } from 'edrolo-ui';
import { useUserCourseProgress } from 'edrolo/domains/bySchoolClass';

interface Props {
  lesson: Lesson;
}

export const StudentProgressCircles = ({ lesson }: Props) => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { profile } = useContext(UserContext);

  const { data, loading, error } = useUserCourseProgress(
    profile.user_id,
    +classId
  );

  if (loading || error) {
    return (
      <Tooltip
        tip={
          error
            ? 'There was an error loading progress data'
            : 'Loading progress data...'
        }
      >
        <Progress.Circles
          outerCircleProps={{
            numerator: 0,
            denominator: 0,
          }}
          innerCircleProps={{
            numerator: 0,
            denominator: 0,
          }}
        />
      </Tooltip>
    );
  }

  const nChunksViewed = Math.round(
    data.lessons[lesson.id]?.visited_chunks.length
  );

  if (!lesson.question_set) {
    return (
      <Tooltip
        tip={`You have viewed ${nChunksViewed} out of ${lesson.chunks.length} lesson parts`}
      >
        <Progress.Circle
          numerator={nChunksViewed}
          denominator={lesson.chunks.length}
          color={enums.ColorHue.BLUE}
          size={enums.Size.LARGE}
        />
      </Tooltip>
    );
  }

  const responseCount = data.exams[lesson.question_set.id]?.response_count || 0;

  return (
    <Tooltip
      tip={`You have viewed ${nChunksViewed} out of ${lesson.chunks.length} lesson parts and completed ${responseCount} out of ${lesson.question_set.question_count} questions`}
    >
      <Progress.Circles
        outerCircleProps={{
          numerator: nChunksViewed,
          denominator: lesson.chunks.length,
          color: enums.ColorHue.BLUE,
        }}
        innerCircleProps={{
          numerator: responseCount,
          denominator: lesson.question_set.question_count,
          color: enums.ColorHue.GREEN,
        }}
      />
    </Tooltip>
  );
};
